import React from 'react';
import { ThemeProvider } from 'emotion-theming';
import * as GeneralTheme from '@90poe/theme';

const { Fonts, WebMetrics, Colors, Breakpoints } = GeneralTheme;

const theme = {
    Fonts,
    WebMetrics,
    Colors,
    Breakpoints
};

const Theme = props => <ThemeProvider {...props} theme={theme} />;

export default Theme;
